/**
 *
 * App
 *
 * This component is the skeleton around the actual containers, and should only
 * contain code that should be seen on all containers. (e.g. navigation bar)
 */

import React from 'react';
import { Helmet } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import { GlobalStyle } from '../styles/global-styles';

import { useTranslation } from 'react-i18next';
import { RootRoutes } from './routes';
import HiikoEnvWrapper from './containers/HiikoEnv/parts/HiikoEnvWrapper/HiikoEnvWrapper';
import AuthWrapper from './containers/Authorization/parts/AuthWrapper/AuthWrapper';
import GlobalWrapper from './containers/Global/parts/GlobalWrapper/GlobalWrapper';

import 'moment/locale/lt';
import ConfigProviderWrapper from './containers/ConfigProviderWrapper/ConfigProviderWrapper';
import PrivacyPolicyWrapper from './containers/Authorization/parts/PrivacyPolicyWrapper/PrivacyPolicyWrapper';

export function App() {
  const { i18n } = useTranslation();

  return (
    <ConfigProviderWrapper>
      <BrowserRouter>
        <Helmet
          titleTemplate="%s - Hikos"
          defaultTitle="Hikos"
          htmlAttributes={{ lang: i18n.language }}
        >
          <meta name="description" content="Hikos application" />
        </Helmet>
        <GlobalWrapper>
          <AuthWrapper>
            <PrivacyPolicyWrapper>
              <HiikoEnvWrapper>
                <RootRoutes />
              </HiikoEnvWrapper>
            </PrivacyPolicyWrapper>
          </AuthWrapper>
        </GlobalWrapper>

        <GlobalStyle />
      </BrowserRouter>
    </ConfigProviderWrapper>
  );
}
